<template>
    <div>
        <v-container fluid>
            <form :ref="this.sum.date">
            <v-row v-if="this.$store.state.monthlyDetail.detailLoading">
                <v-col class="pb-0 pt-0">
                    <v-alert border="right" color="warning" class="sync-correction-time-loading" :prominent="false" icon="mdi-sync">Adatok szinkronizálása folyamatban</v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-0">
                    <v-checkbox
                            :name="'correction_type_'+ this.sum.date"
                            :id="'correction_type_'+ this.sum.date"
                            :input-value="(this.sum.correction.correction_type ? this.sum.correction.correction_type : 1)"
                            :false-value="1"
                            :true-value="2"
                            label="Idő levonás"
                            :disabled="(this.sum.work === '00:00:00' ? true : false)"
                    ></v-checkbox>
                </v-col>
                <v-col class="pb-0">
                    <v-text-field label="Korrekciós Idő" :name="'correction_time_'+ this.sum.date" :id="'correction_time_'+ this.sum.date" :value="(this.sum.correction.correction_time ? this.sum.correction.correction_time : '00:00:00')" outlined type="time" step="1"></v-text-field>
                </v-col>
            </v-row>
                <v-row>
                    <v-col class="pt-0 pb-0">
                        <v-textarea
                                outlined
                                :name="'correction_message_'+ this.sum.date"
                                :id="'correction_message_'+ this.sum.date"
                                :value="(this.sum.correction.correction_message ? this.sum.correction.correction_message : '')"
                                label="Korrekciós üzenet"
                        ></v-textarea>
                    </v-col>
                </v-row>
            <v-row>
                <v-col class="pt-0 pb-0">
                    <v-btn @click.prevent="saveCorrection" color="primary"><v-icon class="pr-1">save</v-icon> Mentés</v-btn>
                    <v-btn v-if="this.sum.correction.length != 0" class="ml-3" color="error" @click.prevent="deleteCorrection()"><v-icon class="pr-1">delete</v-icon> Törlés</v-btn>
                </v-col>
            </v-row>
            </form>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "UserDetailCorrection",

        data () {
            return {
                required: [ v => !!v || 'A mező kitöltése kötelező' ],
            }
        },

        props: {
            sum: {
                required: true,
            }
        },

        methods: {
            async deleteCorrection() {
                let data = { id_correction: this.sum.correction.id }
                await this.$axios({ url: `/correction/delete`, method: 'POST', data: data })
                    .then(resp => {
                        this.$store.dispatch('monthlyDetail/actionMonthlyDetail', { userId: this.$store.state.monthlyDetail.detailUser.id.toString(), emptyBeforeCreate: false })
                        if(resp.status === 200) {
                            this.$swal({ type: 'success', title: 'Sikeres korrekció törlés!'})
                        }
                    })
            },

            async saveCorrection () {

                const Id = this.sum.date
                let valid = true

                let correctionType = 1
                if(this.$refs[Id]['correction_type_' + this.sum.date].checked) {
                    correctionType = 2
                }

                let correctionTime = this.$refs[Id]['correction_time_' + this.sum.date].value

                if(correctionTime.length === 0) {
                    this.$swal({ type: 'error', title: 'Hibás korrekciós idő!'})
                    valid = false
                }

                if(correctionTime.length === 5) {
                    correctionTime = `${correctionTime}:00`
                }

                let correctionMessage = this.$refs[Id]['correction_message_' + this.sum.date].value

                if(correctionType === 1) {

                    let sumTime = this.sumTimes(this.sum.work, correctionTime)
                    if(sumTime > '23:59:59') {
                        this.$swal({ type: 'error', title: 'Korrekciós idő hiba!', text: 'Egy nap a maximális munkaidő: 23:59:59'})
                        valid = false
                    }
                } else {
                    if(correctionTime > this.sum.work) {
                        this.$swal({ type: 'error', title: 'Korrekciós idő hiba!', text: `Erre a napra ${this.$store.state.monthlyDetail.detailUser.name} részéről maximum ${this.sum.work} időt lehet levonni.`})
                        valid = false
                    }
                }

                if(correctionMessage.length === 0) {
                    this.$swal({ type: 'error', title: 'Korrekciós üzenet hiba!', text: 'Kötelező üzenetet hagyni'})
                    valid = false
                }

                let data = {
                    id_user: this.$store.state.monthlyDetail.detailUser.id,
                    correction_date: this.sum.date,
                    correction_type: correctionType,
                    correction_time: correctionTime,
                    correction_message: correctionMessage,
                }

                if(valid === true) {
                    await this.$axios({ url: `/correction/save`, method: 'POST', data: data })
                        .then(resp => {
                            console.log(resp)
                            this.$swal({ type: 'success', title: 'Sikeres korrekció mentés!'})
                            this.$store.dispatch('monthlyDetail/actionMonthlyDetail', { userId: this.$store.state.monthlyDetail.detailUser.id.toString(), emptyBeforeCreate: false })
                        })
                }
            },

            sumTimes (time1, time2) {

                var hour=0
                var minute=0
                var second=0

                var splitTime1= time1.split(':')
                var splitTime2= time2.split(':')

                hour = parseInt(splitTime1[0])+parseInt(splitTime2[0])
                minute = parseInt(splitTime1[1])+parseInt(splitTime2[1])
                hour = hour + parseInt(minute/60)
                minute = parseInt(minute%60)
                second = parseInt(splitTime1[2])+parseInt(splitTime2[2])
                minute = minute + parseInt(second/60)
                second = parseInt(second%60)

                parseInt(hour)
                parseInt(minute)
                parseInt(second)

                if (hour < 10) {
                    hour = `0${hour}`
                }

                if (minute < 10) {
                    minute = `0${minute}`
                }

                if (second < 10) {
                    second = `0${second}`
                }

                return `${hour}:${minute}:${second}`
            }
        }
    }
</script>

<style lang="scss">
    @-webkit-keyframes rotating {
        from{
            -webkit-transform: rotate(0deg);
        }
        to{
            -webkit-transform: rotate(360deg);
        }
    }

    .sync-correction-time-loading {
        i {  -webkit-animation: rotating 2s linear infinite; }
    }
</style>
